import { render, staticRenderFns } from "./TjingTextWrapTooltip.vue?vue&type=template&id=179aa984&scoped=true"
import script from "./TjingTextWrapTooltip.vue?vue&type=script&lang=js"
export * from "./TjingTextWrapTooltip.vue?vue&type=script&lang=js"
import style1 from "./TjingTextWrapTooltip.vue?vue&type=style&index=1&id=179aa984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179aa984",
  null
  
)

export default component.exports